/* eslint-disable max-len */
import _ from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { TilesGrid } from './tiles-grid';

function findItem(items, itemToFind, itemKey) {
  return _.find(items, item => item[itemKey] === itemToFind[itemKey]);
}

function addItem(items, itemToAdd, itemKey) {
  if (!findItem(items, itemToAdd, itemKey)) {
    return [[...items, itemToAdd], true];
  }
  return [items, false];
}

function removeItem(items, itemToRemove, itemKey) {
  if (findItem(items, itemToRemove, itemKey)) {
    return [_.filter(items, item => item[itemKey] !== itemToRemove[itemKey]), true];
  }
  return [items, false];
}

export const MultiSelectionGrid = ({
  itemKey,
  onSelectionChange,
  onRenderCell,
  items,
  selectedItems: propSelectedItems,
  ...rest
}) => {
  const selectedItems = useMemo(() => propSelectedItems || [], [propSelectedItems]);

  // force to re-render when selection changed
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const allItems = useMemo(() => ([...items || []]), [items, selectedItems]);

  const selectItem = useCallback((item, selected) => {
    const action = selected ? addItem : removeItem;
    const [newSelectedItems, updated] = action(selectedItems, item, itemKey);
    if (updated) {
      if (onSelectionChange) {
        onSelectionChange({ item, selected, selectedItems: newSelectedItems });
      }
    }
  }, [itemKey, onSelectionChange, selectedItems]);

  const onRenderCellImpl = useCallback(({ item, index }) => {
    const selected = !!findItem(selectedItems, item, itemKey);
    const fnSelectItem = _.partial(selectItem, item);
    return onRenderCell({
      item, index, selected, selectItem: fnSelectItem,
    });
  }, [itemKey, onRenderCell, selectItem, selectedItems]);

  return <TilesGrid onRenderCell={onRenderCellImpl} items={allItems} config={rest.config} />;
};

MultiSelectionGrid.propTypes = {
  itemKey: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  selectedItems: PropTypes.arrayOf(PropTypes.shape({})),
  onSelectionChange: PropTypes.func,
  onRenderCell: PropTypes.func.isRequired,
};

MultiSelectionGrid.defaultProps = {
  itemKey: 'id',
  items: [],
  selectedItems: [],
  onSelectionChange: undefined,
};
